import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Success from "../../assets/Success.svg";
import generatePDF from "react-to-pdf";
import ShareModal from "../Share";
import { colors } from "../../theme/color";

interface SuccessModalProps {
  show?: boolean;
  noModal?: boolean;
  message?: string | React.ReactNode;
  status?: "error" | "success" | "pending";
  onBack?: () => void;
  reference?: any;
}
const SuccessModal: React.FC<SuccessModalProps> = ({
  show,
  onBack,
  status,
  noModal,
  message,
  reference,
}) => {
  const navigate = useNavigate();
  const [share, toggleShare] = useState(false);
  const handleClick = () => {
    switch (status) {
      case "success":
        return navigate("/");
      case "error":
        if (onBack) {
          onBack?.();
        } else {
          window.history.back();
        }
        break;
      case "pending":
      default:
        window.location.reload();
    }
  };

  const linkToCopy = window.location.href;

  const render = () => (
    <SuccessModalContent className={"content"}>
      <CenteredContent>
        {status === "success" && (
          <CheckMark src="/assets/Success.svg" alt="Check mark" />
        )}
        <SuccessTitle>
          {" "}
          Payment {status === "success" ? "Successful" : status?.toUpperCase()}
        </SuccessTitle>
        <CenteredContent1>
          <Paragraph>{message}</Paragraph>
        </CenteredContent1>
        {status === "success" && (
          <>
            <CloseBtn
              onClick={() => generatePDF(reference, { filename: "page.pdf" })}
            >
              Download Receipt
            </CloseBtn>
            {share && (
              <ShareModal
                isOpen={share}
                onClose={() => toggleShare(!share)}
                linkToCopy={linkToCopy}
              />
            )}

            <CloseBtn
              css={`
                background: transparent;
                margin: 10px 0;
                border: 1px solid ${colors.Primary};
                color: ${colors.Primary};
              `}
              onClick={() => toggleShare(!share)}
            >
              Share Receipt
            </CloseBtn>
          </>
        )}
        <br />
        <span onClick={handleClick}>
          {status == "success"
            ? "Close"
            : status === "error"
              ? "Back to"
              : "Confirm"}{" "}
          checkout
        </span>
      </CenteredContent>
    </SuccessModalContent>
  );

  return !noModal ? (
    <SuccessModalContainer $showModal={!!show}>
      {render()}
    </SuccessModalContainer>
  ) : (
    render()
  );
};

export default SuccessModal;

const SuccessModalContainer = styled.div<{ $showModal: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: ${({ $showModal }) => ($showModal ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
`;

const SuccessModalContent = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 80%;
  height: 18rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    height: 80vh;
  }
`;

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const CenteredContent1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
`;

const CheckMark = styled.img`
  color: green;
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
`;

const SuccessTitle = styled.h1`
  color: #0e0e0e;
  font-size: 18px;
  position: relative;
  font-family: GT Walsheim Pro;
  font-weight: 700;
`;

const Paragraph = styled.p`
  color: #5e5e5e;
  font-size: 16px;
  position: relative;
  font-family: GT Walsheim Pro;
  font-weight: 400;
  margin-bottom: 3rem;
  margin-top: 0;
  text-align: center;
`;

const PriceWrapper = styled.p`
  color: #0e0e0e;
  font-size: 16px;
  position: relative;
  font-family: GT Walsheim Pro;
  font-weight: 700;
  margin-bottom: 3rem;
  margin-top: 0;
  text-align: center;
`;

const CloseBtn = styled.button<{ error?: boolean; css?: string }>`
  background-color: ${({ error }) => (error ? "#a61300" : "#00a603")};
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  text-decoration: none;
  width: 80%;
  ${({ css }) => css || ""}
`;
